/* global google */
import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate, useLocation } from "react-router-dom";
import { setSession } from "../utils/session";
import API_BASE from "../api/api"; 
import "./login.css";

// Importing custom icons from assets folder
import eyeViewIcon from "../assets/view-eye-icon.png";
import eyeHideIcon from "../assets/hide-eye-icon.png";

const LoginSignup = () => {
  const [isSignUp, setIsSignUp] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getRedirectPath = () => {
    const fromState = location.state?.from;

    if (typeof fromState === "string") {
      if (fromState === "/login" || fromState === "/signup") return "/";
      return fromState;
    }

    if (fromState?.pathname) {
      if (fromState.pathname === "/login" || fromState.pathname === "/signup")
        return "/";
      return fromState.pathname;
    }

    return "/";
  };

  const fromPage = getRedirectPath();

  const [loginIdentifier, setLoginIdentifier] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginErrors, setLoginErrors] = useState({});

  const [signupName, setSignupName] = useState("");
  const [signupEmail, setSignupEmail] = useState("");
  const [signupPhone, setSignupPhone] = useState("");
  const [signupPassword, setSignupPassword] = useState("");
  const [signupErrors, setSignupErrors] = useState({});

  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotMessage, setForgotMessage] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showSignupPassword, setShowSignupPassword] = useState(false);

  const [step, setStep] = useState(1);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  /* ---------------- GOOGLE LOGIN ---------------- */
  const handleGoogleLogin = async (response) => {
    try {
      const decoded = jwtDecode(response.credential);

      const res = await fetch(`${API_BASE}/google.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idToken: response.credential, 
          email: decoded.email,
          name: decoded.name
        }),
        credentials: "include"
      });

      const data = await res.json();
      console.log("GOOGLE LOGIN RESPONSE:", data);

if (data.status === "success") {
        setSession(
          {
            id: data.user?.id || data.id || "",   // ✅ user_id
            name: data.user?.name || data.name || decoded.name,
            email: data.user?.email || decoded.email,
            phone: data.user?.phone || data.phone || "",
            role: (data.role || "user").toLowerCase()  // ✅ role
          },
          (data.role || "user").toLowerCase()
        );

        const redirectTo =
          (data.role && data.role.toLowerCase() === "admin")
            ? "/admin"
            : "/";

        navigate(redirectTo, { replace: true }); // ✅ setTimeout hataya

      } else {
        alert(data.message || "Google login failed");
      }

    } catch (err) {
      console.error("GOOGLE LOGIN ERROR:", err);
      alert("Something went wrong during Google login");
    }
  };

  // 🔥 Yahan dono buttons ko render karke innerHTML clean kiya taaki double rendering block ho sake
  useEffect(() => {
    if (window.google) {
      google.accounts.id.initialize({
        client_id: "921531485311-oncevnckv46ag20r1tquipl8b9plhetq.apps.googleusercontent.com",
        callback: handleGoogleLogin
      });

      const renderGoogleBtn = (btnId) => {
        const el = document.getElementById(btnId);
        if (el) {
          el.innerHTML = ""; // Clear existing iframe button completely
          google.accounts.id.renderButton(el, {
            theme: "outline",
            size: "large",
            width: 320
          });
        }
      };

      // Dono ko sath me init karke render kar do taaki DOM nodes jump na karein
      setTimeout(() => {
        renderGoogleBtn("google-login");
        renderGoogleBtn("google-signup");
      }, 150);
    }
  }, []); // Component load par sirf ek baar chalega

  /* ---------------- VALIDATION ---------------- */
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePhone = (phone) => /^[6-9]\d{9}$/.test(phone);

  const validateSignup = () => {
    const errors = {};
    if (!signupName.trim()) errors.name = "Name required";
    if (!validateEmail(signupEmail)) errors.email = "Invalid email";
    if (!validatePhone(signupPhone)) errors.phone = "Invalid phone";
    if (signupPassword.length < 6) errors.password = "Min 6 chars";
    setSignupErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateLogin = () => {
    const errors = {};
    if (!loginIdentifier.trim()) errors.identifier = "Required";
    if (loginPassword.length < 6) errors.password = "Min 6 chars";
    setLoginErrors(errors);
    return Object.keys(errors).length === 0;
  };

  /* ---------------- SIGNUP ---------------- */
  const handleSignup = async (e) => {
    e.preventDefault();
    if (!validateSignup()) return;

    try {
      const res = await fetch(`${API_BASE}/signup.php`, { 
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          name: signupName,
          email: signupEmail,
          phone: "+91" + signupPhone,
          password: signupPassword
        })
      });

      const data = await res.json();
      if (data.status === "success") {
        setSession(
          {
            name: data.user?.name,
            email: data.user?.email,
            phone: data.user?.phone
          },
          data.user?.role?.toLowerCase() || "user"
        );
        navigate("/", { replace: true });
      } else {
        alert(data.message || "Signup failed");
      }
    } catch (err) {
      console.error(err);
      alert("Server error, please try again");
    }
  };

  /* ---------------- LOGIN ---------------- */
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!validateLogin()) return;

    try {
      const res = await fetch(`${API_BASE}/login_user.php`, { 
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          identifier: loginIdentifier,
          password: loginPassword
        })
      });

      const data = await res.json();
if (data.status === "success") {
        setSession(
          {
            id: data.user.id,        // ✅ user_id add kiya
            name: data.user.name,
            email: data.user.email,
            phone: data.user.phone || "",
            role: data.user.role     // ✅ role bhi save karo
          },
          data.user.role.toLowerCase()
        );
        const redirectTo = data.user.role.toLowerCase() === "admin" ? "/admin" : (fromPage || "/");
        navigate(redirectTo, { replace: true }); // ✅ setTimeout hataya
      } else {
        alert(data.message || "Invalid email or password");
      }
    } catch (err) {
      console.error(err);
    }
  };

  /* ---------------- FORGOT PASSWORD ---------------- */
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!forgotEmail.includes("@")) {
      setForgotMessage("Enter valid email");
      return;
    }
    try {
      const res = await fetch(`${API_BASE}/forgot_password.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: forgotEmail })
      });
      const data = await res.json();
      if (data.status === "success") {
        setForgotMessage("Reset link verification initialized");
          } else {
        setForgotMessage(data.message);
      }
    } catch {
      setForgotMessage("Server error");
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      setForgotMessage("Password too short");
      return;
    }
    if (newPassword !== confirmPassword) {
      setForgotMessage("Passwords do not match");
      return;
    }
    try {
      const res = await fetch(`${API_BASE}/reset_password.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: forgotEmail,
          password: newPassword,
          confirm_password: confirmPassword
        })
      });
      const data = await res.json();
      if (data.status === "success") {
        alert("Password updated successfully");
        closeForgotModal();
      } else {
        setForgotMessage(data.message);
      }
    } catch {
      setForgotMessage("Error");
    }
  };

  const closeForgotModal = () => {
    setShowForgot(false);
    setStep(1);
    setForgotEmail("");
    setNewPassword("");
    setConfirmPassword("");
    setForgotMessage("");
  };

  return (
    <div className="login-container-wrapper">
      <div className={`login-container ${isSignUp ? "login-signup-mode" : ""}`}>
        <div className="login-mobile-toggle">
          {!isSignUp ? (
            <p>
              New here?{" "}
              <button onClick={() => setIsSignUp(true)}>Sign Up</button>
            </p>
          ) : (
            <p>
              Already have an account?{" "}
              <button onClick={() => setIsSignUp(false)}>Login</button>
            </p>
          )}
        </div>

        <div className="login-form-container">
          <div className="login-signin-signup">
            
            {/* --- LOGIN FORM --- */}
            <form className={`login-form ${!isSignUp ? "active-form" : "hidden-form"}`} onSubmit={handleLogin}>
              <h2>Welcome Back</h2>

              <input
                type="text"
                placeholder="Email or Phone"
                value={loginIdentifier}
                onChange={(e) => setLoginIdentifier(e.target.value)}
                required={!isSignUp}
              />
              {loginErrors.identifier && (
                <span className="error">{loginErrors.identifier}</span>
              )}

              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={loginPassword}
                  onChange={(e) => setLoginPassword(e.target.value)}
                  required={!isSignUp}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="eye-btn"
                >
                  <img 
                    src={showPassword ? eyeHideIcon : eyeViewIcon} 
                    alt="visibility icon" 
                    className="eye-icon-img"
                  />
                </button>
              </div>
              {loginErrors.password && (
                <span className="error">{loginErrors.password}</span>
              )}

              <p
                onClick={() => setShowForgot(true)}
                style={{ color: "#007BFF", cursor: "pointer" }}
                className="forgot-trigger-text"
              >
                Forgot Password?
              </p>

              <button type="submit">Login</button>
              
              {/* Google Login Container */}
              <div id="google-login" className="google-btn-wrapper"></div>
            </form>

            {/* --- SIGNUP FORM --- */}
            <form className={`login-form ${isSignUp ? "active-form" : "hidden-form"}`} onSubmit={handleSignup}>
              <h2>Create Account</h2>

              <input
                type="text"
                placeholder="Name"
                value={signupName}
                onChange={(e) => setSignupName(e.target.value)}
                required={isSignUp}
              />
              {signupErrors.name && (
                <span className="error">{signupErrors.name}</span>
              )}

              <input
                type="email"
                placeholder="Email"
                value={signupEmail}
                onChange={(e) => setSignupEmail(e.target.value)}
                required={isSignUp}
              />
              {signupErrors.email && (
                <span className="error">{signupErrors.email}</span>
              )}

              <input
                type="tel"
                placeholder="Phone Number"
                maxLength={10}
                value={signupPhone}
                onChange={(e) => setSignupPhone(e.target.value.replace(/\D/g, ""))}
                required={isSignUp}
              />
              {signupErrors.phone && (
                <span className="error">{signupErrors.phone}</span>
              )}

              <div className="password-wrapper">
                <input
                  type={showSignupPassword ? "text" : "password"}
                  placeholder="Password"
                  value={signupPassword}
                  onChange={(e) => setSignupPassword(e.target.value)}
                  required={isSignUp}
                />
                <button
                  type="button"
                  onClick={() => setShowSignupPassword(!showSignupPassword)}
                  className="eye-btn"
                >
                  <img 
                    src={showSignupPassword ? eyeHideIcon : eyeViewIcon} 
                    alt="visibility icon" 
                    className="eye-icon-img"
                  />
                </button>
              </div>
              {signupErrors.password && (
                <span className="error">{signupErrors.password}</span>
              )}

              <button type="submit">Sign Up</button>
              
              {/* Google Signup Container */}
              <div id="google-signup" className="google-btn-wrapper"></div>
            </form>

          </div>
        </div>

        <div className="login-panels-container">
          <div className="login-panel left-panel">
            <div className="login-content">
              <h3>New here?</h3>
              <p>Join Sangit Shree Prakashan and explore our digital library</p>
              <button className="login-btn" onClick={() => setIsSignUp(true)}>
                Sign Up
              </button>
            </div>
          </div>
          <div className="login-panel right-panel">
            <div className="login-content">
              <h3>Welcome Again</h3>
              <p>Already have an account? Log in to continue learning with us.</p>
              <button className="login-btn" onClick={() => setIsSignUp(false)}>
                Login
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ==================== FORGOT PASSWORD MODAL ==================== */}
      {showForgot && (
        <div className="forgot-modal-backdrop">
          <div className="forgot-modal-card">
            <h3>Reset Password</h3>
            <p className="forgot-subtitle">
              {step === 1 
                ? "Enter your registered email address to receive authorization link verification." 
                : "Create a strong new password secure access to your profile credentials workflow."}
            </p>

            {forgotMessage && (
              <div className={`forgot-status-banner ${forgotMessage.includes("valid") || forgotMessage.toLowerCase().includes("error") ? "error-banner" : "success-banner"}`}>
                {forgotMessage}
              </div>
            )}

            {step === 1 ? (
              <form onSubmit={handleForgotPassword} className="forgot-input-group">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  required
                />
                <div className="forgot-action-row">
                  <button type="button" className="forgot-cancel-btn" onClick={closeForgotModal}>
                    Cancel
                  </button>
                  <button type="submit" className="forgot-submit-btn">
                    Continue
                  </button>
                </div>
              </form>
           ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginSignup;